var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--check_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6 6h23v23H6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 19.556l-2.227-2.226a.696.696 0 00-.5-.204.678.678 0 00-.51.204.688.688 0 00-.208.505c0 .198.07.366.208.505l2.63 2.63c.174.173.376.26.607.26.23 0 .433-.087.606-.26l5.332-5.332c.132-.132.2-.3.203-.5a.678.678 0 00-.203-.51.688.688 0 00-.505-.208.688.688 0 00-.506.208l-4.927 4.928zm1.361 7.048a8.87 8.87 0 01-3.55-.717 9.196 9.196 0 01-2.892-1.946 9.196 9.196 0 01-1.946-2.89 8.862 8.862 0 01-.717-3.55c0-1.259.238-2.443.716-3.55a9.196 9.196 0 011.946-2.892 9.195 9.195 0 012.89-1.946 8.86 8.86 0 013.55-.717 8.87 8.87 0 013.55.716 9.197 9.197 0 012.892 1.946 9.195 9.195 0 011.947 2.89 8.862 8.862 0 01.717 3.55 8.87 8.87 0 01-.717 3.55 9.197 9.197 0 01-1.946 2.892 9.196 9.196 0 01-2.89 1.947 8.862 8.862 0 01-3.55.717zm-.001-1.438c2.14 0 3.953-.742 5.438-2.228 1.486-1.485 2.228-3.298 2.228-5.438 0-2.14-.742-3.954-2.228-5.439-1.485-1.485-3.298-2.228-5.438-2.228-2.14 0-3.954.743-5.439 2.228-1.485 1.486-2.228 3.298-2.228 5.439 0 2.14.743 3.953 2.228 5.438 1.486 1.486 3.298 2.228 5.439 2.228z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--check-f9b5043489b9a5e58b5e8c052f0017ef.svg";
export { SvgIconCircleLimeCheck as Component };